<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="#422AFB" width="19px" height="19px" viewBox="-4 0 32 32" version="1.1" stroke="#422AFB">

    <g id="SVGRepo_bgCarrier" stroke-width="0"/>

    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>

    <g id="SVGRepo_iconCarrier"> <title>laptop</title> <path d="M19.16 21.6h-14c-1.48 0-2.72-1.2-2.72-2.72v-8.92c0-1.48 1.2-2.72 2.72-2.72h14.040c1.48 0 2.72 1.2 2.72 2.72v8.92c-0.040 1.52-1.28 2.72-2.76 2.72zM5.16 8.96c-0.56 0-1.040 0.44-1.040 1.040v8.92c0 0.56 0.44 1.040 1.040 1.040h14.040c0.56 0 1.040-0.44 1.040-1.040v-8.96c0-0.56-0.44-1.040-1.040-1.040l-14.040 0.040zM23.48 24.72h-22.64c-0.48 0-0.84-0.36-0.84-0.84s0.36-0.84 0.84-0.84h22.64c0.48 0 0.84 0.36 0.84 0.84s-0.4 0.84-0.84 0.84z"/> </g>

  </svg>
</template>

<script>
export default {
  name: "EquipmentIcon",
  props: {
    size: {
      type: Number,
      default: 19
    },
    fill: {
      type: String,
      default: 'currentColor'
    },
  },
}
</script>
